import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/content";
import { useReveal } from "../hooks/useReveal";

const ServicesGrid = () => {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            data-testid="services-section"
            className="py-24 md:py-40 bg-samora-bone"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16 md:mb-24 items-end reveal">
                    <div>
                        <p className="eyebrow mb-6">The Studio Practice</p>
                        <h2
                            className="font-display text-samora-ink leading-[0.95] tracking-tight"
                            style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
                        >
                            Twelve disciplines.<br />
                            <span className="italic font-serif text-samora-gold">
                                One considered home.
                            </span>
                        </h2>
                    </div>
                    <p className="text-samora-text/75 text-base md:text-lg leading-relaxed max-w-md md:justify-self-end">
                        Whether it's a whole villa or a single, essential
                        kitchen, we bring the same studio discipline —
                        drawings, renders, honest materials and a fixed
                        timeline.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                    {SERVICES.map((s, i) => (
                        <div
                            key={s.title}
                            data-testid={`service-${s.title
                                .toLowerCase()
                                .replace(/[^a-z0-9]+/g, "-")}`}
                            className={`reveal group border-t border-samora-ink/15 py-8 md:py-12 md:pr-8 ${
                                i % 3 !== 2 ? "lg:border-r" : ""
                            } ${i % 2 !== 1 ? "md:border-r lg:border-r" : ""}`}
                            style={{
                                borderRightColor: "rgba(17,17,17,0.15)",
                            }}
                        >
                            <div className="flex items-start justify-between gap-4 md:pl-6">
                                <div>
                                    <span className="font-serif text-samora-gold text-sm">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <h3 className="font-display text-2xl md:text-3xl text-samora-ink mt-2">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 text-samora-text/70 text-sm md:text-base leading-relaxed max-w-sm">
                                        {s.blurb}
                                    </p>
                                </div>
                                <ArrowUpRight
                                    size={18}
                                    className="text-samora-ink/40 group-hover:text-samora-gold transition-colors flex-shrink-0"
                                />
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-16 flex justify-center reveal">
                    <Link
                        to="/services"
                        data-testid="services-cta"
                        className="btn-outline"
                    >
                        Explore Full Services
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ServicesGrid;
